import {useNavigate} from "react-router-dom";
import {truchateString} from "../../../../utils/utils";



export default function BlogCardNew({
                                     className,
                                     title,
                                     refreshCallBack,
                                     metaDescription,
                                     date,
                                     thumbnail,
                                     variant,
                                     ...props
                                 }) {
    let image = thumbnail
    let style = variant && variant === "card" ? "rounded-md bg-white shadow-sm p-[0.75rem]" : "";
    const navigate = useNavigate();
    return (
        <div className={` ${className} ${style} gap-2 flex border-[1px] rounded-[13px] flex-col`}>
            <img
                src={image}
                alt={"blog"}
                className={"w-full rounded-[13px] max-h-[255px] min-h-[255px] object-cover "}
            />

            <div className={"flex flex-col gap-1 py-[12px] px-[24px]  "}>
                <p className={"font-medium"}>
                    {title}
                </p>
                <div
                    onClick={() => {
                        navigate("/blogs/" + title)

                    }}
                    className={"cursor-pointer text-tertiary-900 hover:underline"}>
                    Read More
                </div>

            </div>
        </div>

    )
}